import { useEffect } from "react";

/**
 * Mantém playbackRate de um vídeo em sincronia com o estado.
 */
export function usePlayback(videoRef, speed) {
  useEffect(() => {
    const interval = setInterval(() => {
      if (videoRef?.current) {
        videoRef.current.playbackRate = speed;
      }
    }, 400);
    return () => clearInterval(interval);
  }, [videoRef, speed]);
}
